/**
 * @zag/workflows/models
 *
 * Shared TypeScript types and Arktype schemas for the workflow system.
 * Used by both backend (@zag/workflows/api) and frontend (@zag/workflows/ui).
 */

export * from './lib/workflow-definition.model';
export * from './lib/workflow-run.model';
export type { WorkflowStepHandler } from './lib/workflow-step-handler.interface';
export * from './lib/workflows.features';
